function dollars(cents) {
  const amount = (cents / 100)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // This regex adds commas for every 3 digits

  return amount;
}

export default dollars;
